module.exports = "<p>\n  company-offers works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/company-modal/company-offers/company-offers.component.html
// module id = ../../../../../src/app/_components/company-modal/company-offers/company-offers.component.html
// module chunks = main